const basePath1 = '/assets/icons/logo/programs/';
const basePath2 = '/assets/icons/logo/socials/';
const basePath3 = '/assets/icons/logo/technologies/';
const basePath4 = '/assets/icons/logo/experiences/';

const programs = {
    altium: basePath1 + '/altium.jpg',
    autocad: basePath1 + '/autocad.jpg',
    eplan: basePath1 + 'eplan.png',
    matlab: basePath1 + '/matlab.jpg',
    solidworks: basePath1 + '/solidworks.png',
    stm32: basePath1 + '/stm32.png',
    tiaportal: basePath1 + '/tiaportal.png',
    vscode: basePath1 + '/vscode.png',
    c: basePath1 + '/c.svg',
    factoryio: basePath1 + '/factoryio.svg',
    figma: basePath1 + '/figma.svg',
    proteus: basePath1 + '/proteus.svg',
    davinci: basePath1 + '/davinci-resolve.svg',
    logic: basePath1 + '/logic-analyzer.svg',
    firebase: basePath1 + '/firebase.svg',
    arduino: basePath1 + '/arduino.svg',
}

const socials = {
    google: basePath2 + '/google.svg',
    github: basePath2 + '/github.svg',
    linkedin: basePath2 + '/linkedin.svg',
    instagram: basePath2 + '/instagram.svg',
}

const technologies = {
    css: basePath3 + '/css.svg',
    html: basePath3 + '/html.svg',
    js: basePath3 + 'js.svg',
    node: basePath3 + '/node.svg',
    react: basePath3 + 'react.svg',
    ts: basePath3 + '/ts.svg',
    chatgpt: basePath3 + '/chatgpt.svg',
    flutter: basePath3 + '/flutter.svg',
    mysql: basePath3 + '/mysql.svg',
    php: basePath3 + '/php.svg',
}

const experiences = {
    afl: basePath4 + '/afl.png',
    baun: basePath4 + '/baun.png',
    coruh: basePath4 + 'coruh.png',
    euas: basePath4 + '/euas.png',
}


export const myIcons = {
    programs,
    socials,
    technologies,
    experiences,
};